import { motion } from "motion/react";

export const fadeInVariants = {
  hidden: { opacity: 0, y: 100 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      bounce: 0.1,
      delay,
      ease: "easeOut",
    },
  }),
};

export const fadeInStaggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0,
    },
  },
};

export const fadeInStaggerItem = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      bounce: 0.1,
      ease: "easeOut",
    },
  },
};

export function FadeIn({ children, delay = 0, className, as: Tag = "div" }) {
  const MotionTag = motion[Tag] ?? motion.div;

  return (
    <MotionTag
      className={className}
      variants={fadeInVariants}
      initial="hidden"
      animate="visible"
      custom={delay}
    >
      {children}
    </MotionTag>
  );
}

export function StaggerIn({
  children,
  className,
  as: Tag = "div",
  staggerDelay = 0.05,
  initialDelay = 0,
}) {
  const MotionTag = motion[Tag] ?? motion.div;

  return (
    <MotionTag
      className={className}
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: staggerDelay,
            delayChildren: initialDelay,
          },
        },
      }}
      initial="hidden"
      animate="visible"
    >
      {children}
    </MotionTag>
  );
}

export function StaggerItem({ children, className, as: Tag = "div" }) {
  const MotionTag = motion[Tag] ?? motion.div;

  return (
    <MotionTag className={className} variants={fadeInStaggerItem}>
      {children}
    </MotionTag>
  );
}
